import React, { FC, useEffect, useRef } from 'react';
import Svg from 'svg-inline-react';
import { throttle } from 'lodash';
import FrChatGreySvg from '@src/svgs/fr-chat-grey.svg';
import { CANDIDATES_FILTER_OPTIONS, FILTER_ALL } from '../constants/filters';
import { Header } from './Header';
import { CandidateFilter } from './CandidateFilter';
import { Candidate } from './Candidate';
import { CandidateSkeleton } from './Candidate/CandidateSkeleton';
import { SidebarProps } from './props';
import './styles.scss';

export const Sidebar: FC<SidebarProps> = ({
  openings,
  teamMembers,
  hasInboxAccess,
  loadMoreMessageThreads,
  isMessageThreadsLoading,
  messageThreadsPagination,
  isMessageThreadsInitialLoading,
  messageThreads,
  openedChat,
  selectChat,
  openingId,
}) => {
  const messageThreadsListRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const onWindowScroll = throttle(() => {
      if (messageThreadsListRef.current) {
        const { scrollHeight, scrollTop, offsetHeight } = messageThreadsListRef.current;

        const distanceFromBottom = scrollHeight - scrollTop - offsetHeight;

        if (distanceFromBottom <= 200) {
          loadMoreMessageThreads();
        }
      }
    }, 250);

    if (messageThreadsListRef.current) {
      messageThreadsListRef.current.addEventListener('scroll', onWindowScroll);
    }

    return () => {
      if (messageThreadsListRef.current) {
        messageThreadsListRef.current.removeEventListener('scroll', onWindowScroll);
      }

      onWindowScroll.cancel();
    };
  }, [isMessageThreadsLoading, messageThreadsPagination?.hasMoreResults, messageThreadsPagination?.maxCursor]);

  return (
    <div className="inbox-sidebar">
      <Header />

      <div className="inbox-sidebar__candidates">
        <CandidateFilter
          openingsFilterOptions={[FILTER_ALL, ...openings]}
          options={CANDIDATES_FILTER_OPTIONS}
          recruiters={teamMembers}
          shouldShowRecruitersList={hasInboxAccess}
        />

        <div className="inbox-sidebar__candidates-wrapper" ref={messageThreadsListRef}>
          {!isMessageThreadsInitialLoading &&
            messageThreads?.map(chat => {
              return (
                <Candidate
                  applicationId={chat.application?.id}
                  chatId={chat.id}
                  className={openedChat && chat.id === openedChat.id ? 'selected' : undefined}
                  hasUnread={chat.isUnread}
                  key={chat.id}
                  lastMessage={chat.messages.result[0]?.text || ''}
                  lastMessageCreatedAt={chat.latestMessageSentAt || undefined}
                  openingId={openingId}
                  selectChat={selectChat}
                  topic={chat.opening?.title || undefined}
                  userAvatarColor={chat.user.avatarColor || undefined}
                  userName={chat.user.name || ''}
                />
              );
            })}

          {isMessageThreadsLoading &&
            [0, 1, 2].map(item => {
              return <CandidateSkeleton key={item} />;
            })}

          {!isMessageThreadsInitialLoading && !messageThreads?.length && (
            <div className="inbox-sidebar__candidates-container">
              <Svg className="inbox-sidebar__candidates-container-icon" src={FrChatGreySvg} />

              <div className="inbox-sidebar__candidates-container-text">
                There are no open conversations <br />
                at the moment.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
